class IFrame {
    constructor() {
        this.redirectOnIframeLoad();
        this.stripColonsFromLabels();
        this.OrderSummaryGiftButton();
    }

    redirectOnIframeLoad() {
        const order_confirmation_header = document.querySelector(
            ".spx-header-container__checkout--order-confirmation",
        );
        if (order_confirmation_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/order-confirmation" },
                "*",
            );
        }

        const details_header = document.querySelector(".MyDetailsHeading");
        if (details_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/account/details" },
                "*",
            );
        }

        const password_header = document.querySelector(
            ".PasswordChangedMessage, .PasswordSetMessage",
        );

        if (password_header) {
            password_header.innerHTML =
                "<p><b>Your password has been successfully updated.</b></p><p>You will now be re-directed to your Account area.</p>";
            password_header.classList.add("show");
            window.parent.postMessage(
                { type: "navigate", url: "/account" },
                "*",
            );
        }

        const preferences_header = document.querySelector(
            ".MyPreferencesHeading",
        );
        if (preferences_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/account/preferences" },
                "*",
            );
        }

        const tickets_header = document.querySelector(".MyTicketsHeading");
        if (tickets_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/account/orders/tickets" },
                "*",
            );
        }

        const orders_header = document.querySelector(".MyOrdersHeading");
        if (orders_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/account/orders" },
                "*",
            );
        }

        const memberships_header = document.querySelector(
            ".MyMembershipsHeading",
        );
        if (memberships_header) {
            window.parent.postMessage(
                { type: "navigate", url: "/account/memberships" },
                "*",
            );
        }
    }

    OrderSummaryGiftButton() {
        const header = document.querySelector(
            ".spx-button-tertiary__checkout--credit",
        );
        if (header) {
            header.innerHTML = "Redeem gift voucher";
        }
    }

    stripColonsFromLabels() {
        const elements = document.querySelectorAll(".left");

        elements.forEach((element) => {
            let text = element.textContent;
            if (text.endsWith(":")) {
                element.textContent = text.slice(0, -1);
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new IFrame();
});

export default IFrame;
